/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './BasePanel.scss';

class BasePanel extends React.Component {

  validateUserCredentials = () => {
    // let features = [];
    // this.props.user.user.roles.forEach((v, i) => {
    //   v.features.forEach((a, i) => {
    //     const hasThisFeature = _.find(features, (o) => o.rid === a.rid);
    //     if (!hasThisFeature) features.push(a)
    //   });
    // });
    // const hasFeatureWithCode = _.find(features, (o) => o.kod === this.props.userHasFeatureCode);
    // if (hasFeatureWithCode) return true;
    // return false;
    return true;
  }

  render() {
    const isOk = this.validateUserCredentials();
    return isOk ? (
      <div className={this.props.fullWidth ? 'col-xs-12' : 'basePanelContent'}>
        <div className={`panel panel-${this.props.panelType}`}>
          <div className="basePanelHeading">{this.props.panelTitle}</div>
          <div className="panel-body">
            {this.props.children}
          </div>
        </div>
      </div>
    ) : null;
  }
}

BasePanel.PropTypes = {
  panelTitle: PropTypes.string.isRequired,
  panelType: PropTypes.string.isRequired,
  userHasFeatureCode: PropTypes.string.isRequired,
};

export default withStyles(s)(BasePanel);



// WEBPACK FOOTER //
// src/components/Modals/Settings/Panels/BasePanel.js